export default "__VITE_ASSET__CJ4yPSud__"